import styled from 'styled-components';
import ModalLayout from '@/layouts/ModalLayout';
import InputField from '@/components/InputField';
import colors from '@/design/colors';
import { Text } from '@/design/typography';

export const Dialog = styled(ModalLayout)`
  width: 447px;
  height: 650px;
  position: fixed;

  top: auto !important;
  left: calc(100% - 220px) !important;
  bottom: -325px !important;

  > div {
    height: 100%;
    display: flex;
    flex-direction: column;

    > div:nth-child(2) {
      flex: 1;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
`;

export const HelpForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > div > div {
    width: 100%;
  }

  overflow-y: auto;
  overflow-x: hidden;
`;

export const FormInput = styled(InputField)`
  width: 100%;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 16px;

  button {
    width: 50%;
  }

  button + button {
    margin-left: 16px;
  }
`;

export const ErrorText = styled.span`
  ${Text(14)};
  color: ${colors.red100};
  margin-top: 4px;
`;
